import type { RouteObject } from 'react-router-dom'

const masterReportRoute: RouteObject = {
  children: [
    {
      children: [{ lazy: () => import('@/pages/master-report/query-data/page'), path: '' }],
      path: 'query-data',
    },
  ],
  path: 'master-report',
}

export default masterReportRoute
